import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Knob } from 'primeng/knob';
import { InputNumberModule } from 'primeng/inputnumber';
import { Slider } from 'primeng/slider';

import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule, MatFormField } from '@angular/material/form-field';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule, MatSlideToggle } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { coerceNumberProperty } from '@angular/cdk/coercion';

import { TeamLoginService } from '../auth/login/teamlogin.service';
import { TeamCalculatorService } from './teamcalculator.service';
import { Model } from './teamcalculator.interface';
import { DropDownDataService } from '../logging/dropdown.service';
import { Cultivars } from '../../interfaces/dropdown.interface';
import { TeamLoginComponent } from '../auth/login/teamlogin.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { Button } from 'primeng/button';
import { DecimalPipe, PercentPipe, CurrencyPipe } from '@angular/common';

@Component({
    selector: 'app-teamcalculator',
    templateUrl: './teamcalculator.component.html',
    styleUrls: ['./teamcalculator.component.scss'],
    imports: [ 
      Knob, 
      Slider,
      InputNumberModule,
      FormsModule, 
      Button, 
      MatFormField, 
      MatSelect, 
      MatOption, 
      MatSlideToggle, 
      TeamLoginComponent, 
      DecimalPipe, 
      PercentPipe, 
      CurrencyPipe]
})
export class TeamCalculatorComponent implements OnInit {
	memberSelect;
	calComplete: boolean = false;
	wnis = 5000;
  dnis: number = 0;
	moisture = 6;
	skr = 30.2;
	uskr = 1.6;
  darks = 0;
  smalls = 0;
  transportkm = 0;
	checked = false;
  disabled;
  color;
  checkedVAT = true;
  cultivarIndex: string;
  cultivar: Cultivars = {"idcultivar": "22", "cultivar": "695 (Beaumont)", "variety": "Integ"};

  @ViewChild('knob25') knob25: Knob;
  @ViewChild('knob22') knob22: Knob;
  @ViewChild('knob20') knob20: Knob;
  @ViewChild('knob18') knob18: Knob;

  constructor(
  	private lS: TeamLoginService,
		public cS: TeamCalculatorService,
    public dDDS: DropDownDataService,
    private cD: ChangeDetectorRef 
  	) { }

  ngOnInit() {
    this.reset();
    window.scrollTo(0,0);
    this.onLoad();
  }

  ngOnDestroy() {
    this.reset();
  }

  async onLoad() {
    this.cS.loadPriceModel();
    this.dDDS.getDropdown("priceModelList");
    this.dDDS.dropdown['cultivarList'] = await this.lS.loadData("cultivarList");
    this.cultivarIndex = this.getCultivarIndex(22);
    this.onChoose();
  }

  isAuthenticated() {
    return this.lS.isAuthenticated();
  }

  showknob(size,event) {
    let sum = this.cS.sizes['dnis25'] + this.cS.sizes['dnis22'] + this.cS.sizes['dnis20'];
    if (sum >= 100) {
      this.cS.sizes['dnis18'] = 0;
      this.cS.sizes[size] = 100 
       - (size=='dnis25' ? 0 : this.cS.sizes['dnis25'])
       - (size=='dnis22' ? 0 : this.cS.sizes['dnis22'])
       - (size=='dnis20' ? 0 : this.cS.sizes['dnis20']);
    }
    if (sum<100) {
      this.cS.sizes['dnis18'] = Math.max(0, 100 - this.cS.sizes['dnis25'] - this.cS.sizes['dnis22'] - this.cS.sizes['dnis20']);
    }
    this.cS.sizes[size] = Math.min(this.cS.sizes[size], 100
     - (size=='dnis25' ? 0 : this.cS.sizes['dnis25'])
     - (size=='dnis22' ? 0 : this.cS.sizes['dnis22'])
     - (size=='dnis20' ? 0 : this.cS.sizes['dnis20'])
     - (size=='dnis25' ? 0 : this.cS.sizes['dnis18']));
    this.knob18.writeValue(this.cS.sizes['dnis18']);
    switch (size) {
      case 'dnis25':
        this.knob25.writeValue(this.cS.sizes['dnis25']);
        break;
      case 'dnis22':
        this.knob22.writeValue(this.cS.sizes['dnis22']);
        break;
      case 'dnis20':
        this.knob20.writeValue(this.cS.sizes['dnis20']);
        break;
      case 'dnis18':
        this.knob18.writeValue(this.cS.sizes['dnis18']);
        break;
      default:
        break;
    }
  }
  
  plus(size) {
    this.cS.sizes[size] += 1;
    this.showknob(size, this.cS.sizes[size]);
  }

  minus(size) {
    this.cS.sizes[size] -= 1;
    this.showknob(size, this.cS.sizes[size]);
  }

  getCultivarIndex(idcultivar: number) {
    for (var i = 0; i < this.dDDS.dropdown.cultivarList.length; i++) {
      if (this.dDDS.dropdown.cultivarList[i]['idcultivar'] == idcultivar) {
        return i + "";
      }
    }
  }

  onChoose() {
    this.cultivar = this.dDDS.dropdown.cultivarList[this.cultivarIndex];
  }

  onCurrencySelected(currency: string) {
    this.cS.selectedCurrency = currency.toUpperCase();
    if (this.calComplete) {
      this.onCalculate();
    }
  }

  onModelSelected(model: Model) {
    this.cS.currentModel = model.model;
    this.cS.setPriceModel(model);
    this.calComplete = false;
  }

  async onCalculate() {
    var calc = await this.cS.calculatePricing(+this.wnis,+this.moisture/100,+this.skr/100,+this.uskr/100,this.checked,this.checkedVAT,+this.darks/100,+this.cultivar.idcultivar,+this.smalls,+this.transportkm);
  	this.calComplete = true;
    window.scrollTo(0,0);
    this.cD.detectChanges();
  }

  async onNewCalculation() {
    this.calComplete = await false;
    await this.cD.detectChanges();
    await this.cD.detectChanges();
    window.scrollTo(0,0);
  }

  reset() {
    this.cS.selectedCurrency = "ZAR";
    this.cS.sizes = {"dnis18": 0, "dnis20": 0, "dnis22": 0, "dnis25": 0};
    this.wnis = 5000;
    this.dnis = 0;
    this.moisture = 6;
    this.skr = 30.2;
    this.uskr = 1.6;
    this.darks = 0;
    this.smalls = 0;
    this.transportkm = 0;
    this.checked = false;
    this.checkedVAT = true;
  }

}
